import * as types from "./notificationsTypes";
import { groupBy } from "lodash";

const initialState = {
  loading: false,
  data: [],
  totalNew: 0,
  total: 0,
  page: 0,
  error: "",
  bookingNoti: {
    loading: false,
    data: [],
    totalNew: 0,
    total: 0,
    error: ""
  },
  systemNoti: {
    loading: false,
    data: [],
    totalNew: 0,
    total: 0,
    error: ""
  },
  promoteNoti: {
    loading: false,
    data: [],
    totalNew: 0,
    total: 0,
    error: ""
  }
};

export default function notification(state = initialState, action = {}) {
  switch (action.type) {
    case types.GET_NOTIFICATION:
      return { ...state, loading: true };
    case types.GET_NOTIFICATION_ON_PAGE:
      if (!action.payload.type) {
        return { ...state, loading: true };
      } else {
        return {
          ...state,
          [action.payload.type]: {
            ...state[action.payload.type],
            loading: true
          }
        };
      }

    case types.GET_NOTIFICATION_BY_TYPE_SUCCESS:
      return {
        ...state,
        [action.payload.type]: {
          loading: false,
          error: "",
          ...action.payload.data
        }
      };

    case types.GET_NOTIFICATION_BY_TYPE_FAIL:
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          loading: false,
          error: action.payload.error
        }
      };
    case types.GET_NOTIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        data: action.payload,
        totalNew: groupBy(action.payload, "isRead").false
          ? groupBy(action.payload, "isRead").false.length
          : 0
      };
    case types.GET_NOTIFICATION_FAIL:
      return { ...state, loading: false, error: action.payload };

    case types.GET_MORE_NOTIFICATION:
      return { ...state, loading: true };
    case types.GET_MORE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        data: [...state.data, ...action.payload.data],
        total: action.payload.total,
        totalNew: action.payload.totalNew,
        page: state.page + 1
      };
    case types.GET_MORE_NOTIFICATION_FAIL:
      return { ...state, loading: false, error: action.payload };

    case types.CLEAR_NOTIFICATION_AT_STORE:
      return initialState;
    default:
      return state;
  }
}
